






































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import SmilingFacePlusIcon from '@front-app/components/buttons/reactions/SmilingFacePlusIcon.vue';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import ReactionButtonComponent from '@front-app/components/buttons/ReactionButton.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { ReactionButton } from '@front-app/components/buttons/useReactionButtons';

export default defineComponent({
	components: {
		ButtonList,
		ReactionButtonComponent,
		SimpleDropdown,
		SmilingFacePlusIcon,
		TrButton,
	},
	props: {
		reactionButtons: {
			type: Array as PropType<ReactionButton[]>,
			required: true,
		},
	},
	setup() {
		const isOpen = ref(false);

		const isSafariBrowser = computed(() => {
			const userAgentString = navigator.userAgent;
			if (!userAgentString.includes('Chrome') && userAgentString.includes('Safari')) {
				return true;
			}
			return false;
		});

		return {
			isOpen,
			// Util
			DropdownPosition,
			isSafariBrowser,
		};
	},
});
